import { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCirclePlus, faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { toast } from 'react-toastify'

import { useEmailAttachmentMutation } from './emailsApiSlice'
import { useNavigate } from "react-router-dom"
import { Editor } from "@tinymce/tinymce-react"
import { useGetUsersQuery } from '../users/usersApiSlice'
import useAuth from "../../hooks/useAuth"


const FileUploader = () => {

    const {token}=useAuth()

    let server_url=''
    let sms_url=''
    let file_url=''
    if (process.env.NODE_ENV === 'production') {
        server_url='https://dpe-mern-server.onrender.com/files/uploads'
        sms_url='https://dpe-mern-server.onrender.com/files/sms'
        file_url='https://dpe-mern-server.onrender.com/uploads'
    } else {
        server_url='http://localhost:3500/files/uploads'
        sms_url='http://localhost:3500/files/sms'
        file_url='http://localhost:3500/uploads'
    }

    const [sendType, setSendType] = useState('email')

    // get current user info
    const { userId } = useAuth()
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    })

    // email variables
    const navigate = useNavigate()
    const editorRef = useRef(null);
    
    const [sendTo, setSendTo] = useState('')
    const sendFrom = `${user.firstname} ${user.lastname} <webmaster@smidtmanagement.com>`
    const [replyTo, setReplyTo] = useState(user.email)
    const [subjectText, setSubjectText] = useState('')
    const [htmlText, setHtmlText] = useState('')
    const [attachment, setAttachment]=useState('')
    const [smsNumber, setSmsNumber] = useState('')
    const [smsMessage, setSmsMessage] = useState('')


    // email functions
    const [emailFile, {data}] = useEmailAttachmentMutation()

    useEffect(() => {
        if(data) {
            if (data.message) {
                toast.error(<>Email was NOT Send:<br/>{data.message}</>);
            } else {
                toast.success("Email was Send");
                navigate(`/dash/hep`)
            }
        }

    }, [data, navigate])


    // field changes
    const onSendToChanged = e => setSendTo(e.target.value)
    const onReplyToChanged = e => setReplyTo(e.target.value)
    const onSubjectChanged = e => setSubjectText(e.target.value)
    const onSendTypeChanged= e => setSendType(e.target.value)
    const onPhoneChanged = e => setSmsNumber(e.target.value)
    const onMessageChanged= e => setSmsMessage(e.target.value)


    // save and send email
    let canSave
	canSave = [sendTo, sendFrom, replyTo, subjectText, htmlText, attachment].every(Boolean)
    const onEmailFileClicked = async (e) => {
		e.preventDefault()

		if(canSave) {
			await emailFile({ sendTo, sendFrom, replyTo, subjectText, htmlText, attachment})
		} else {
			toast.error('All fields are required');
		}
    }


    //////////////////////////////////////////////////////////////////////////
    // send file via SMS

    async function onSMSFileClicked() {

        try {

            let canSend=true

            const phoneRegex = /^\+?(\d{1,3})?[-.\s]?(\d{3})[-.\s]?(\d{4})$/;
            if (!phoneRegex.test(smsNumber)) {
                canSend=false
                toast.error('Phone number should be like 123-456-7890')
            }

            if (!smsMessage){
                canSend=false
                toast.error('Message is required')
            }

            if (canSend) {
                const msg = {message:smsMessage, number:smsNumber}

                const response = await fetch(sms_url, {
                    method: 'POST',
                    body: JSON.stringify(msg),
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json();

                if (response.status===200) {
                    toast.success(data.message);
                    console.log(data.messageId)
                    navigate(`/dash/hep`)
                } else {
                    toast.error(data.message);
                    console.log(data.error)
                }
            }

        } catch (error) {
            toast.error('Error sending Text Message:' + error);
        }
    }

    ////////////////////////////////////////////////////////////////////////
    // upload variables
    const [file, setFile] = useState('')
    const [isUploaded, setIsUploaded] = useState(false)
    let canUpload=true

    // upload functions

    const handleFileChange = (e) => {
        if (e.target.files) {
            let filetype = e.target.files[0].type
            if (filetype==='application/pdf') {
                const hasSpace = /\s/.test(e.target.files[0]);
                if (hasSpace) {
                    setFile('')
                    canUpload=false
                    toast.error('Filename can not have empty space')
                } else {
                    setFile(e.target.files[0])
                }                
            } else {
                setFile('')
                canUpload=false
                toast.error('Only PDF files are allowed')
            }
            
            
        }
    }

    async function handleFileUpload() {
        if ( !file || canUpload === false ) {
            toast.error('Please Select a PDF File with proper file name')
            return
        }

        const formData = new FormData();
        formData.append('file', file);


        try {

            const response = await fetch(server_url, {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${token}`,
                  },
              });

            const data = await response.json();

            if (response.status===200) {
                toast.success('File was Uploaded');
                setAttachment(data.filename)
                setIsUploaded(true)
                const fileUrl=file_url + "/" + data.filename
                setSmsMessage("Here is a copy of your home program: " + fileUrl)

            } else {
                toast.error(<>File was NOT Uploaded:<br/>{data.message}</>);
            }

        } catch (error) {
            toast.error('Error uploading file:' + error);
        }
    }



    // show content
    let content=null

    if (isUploaded) {

        if (sendType==='email') {
            // show email fields
            content=(
                <section id="main_content">
                    <header>
                        <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faEnvelope} style={{fontSize:"30px", marginRight:"5px"}} />Email File</h1>
                        <div className='row'>
                            <div className='col-md-7'><br/></div>
                            <div className="col-md-3 text-end">
                                <select className='form-select' id="sendType" value={sendType} onChange={onSendTypeChanged}>
                                    <option value="sms">Send via Text</option>
                                    <option value="email">Send via Email</option>
                                </select>
                            </div>`
                        </div>
                    </header>
                    <main>
                        <form onSubmit={e => e.preventDefault()}>
                            <div className="row mb-3">
                                <div className="col-md-5">
                                    <label className="form-label" htmlFor="sendTo">
                                        Send To:
                                    </label>
                                    <input
                                        className="form-control"
                                        id="sendTo"
                                        name="sendTo"
                                        type="email"
                                        autoComplete="off"
                                        value={sendTo}
                                        onChange={onSendToChanged}
                                    />
                                </div>
                                <div className="col-md-5">
                                    <label className="form-label" htmlFor="replyTo">
                                        Reply To:
                                    </label>
                                    <input
                                        className="form-control"
                                        id="replyTo"
                                        name="replyTo"
                                        type="email"
                                        autoComplete="off"
                                        value={replyTo}
                                        onChange={onReplyToChanged}
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-10">
                                    <label className="form-label" htmlFor="subject">
                                        Subject:
                                    </label>
                                    <input
                                        className="form-control"
                                        id="subject"
                                        name="subject"
                                        type="text"
                                        autoComplete="off"
                                        value={subjectText}
                                        onChange={onSubjectChanged}
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-10">
                                    <Editor
                                        apiKey="mprrt6hl7gkebqsue1jr2da25cai059a5vwnw9xtv4smrptk"
                                        onInit={(evt, editor) => (editorRef.current = editor)}
                                        value={htmlText}
                                        onEditorChange={(newContent) => setHtmlText(newContent)}
                                        init={{
                                            skin: (localStorage.getItem('theme')==='dark' ? "oxide-dark" : "oxide"),
                                            content_css: (localStorage.getItem('theme')==='dark' ? "dark" : "default"),
                                            height: 500,
                                            menubar: true,
                                            plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                                            toolbar: 'align | numlist bullist indent outdent | bold italic underline strikethrough backcolor fontsize | undo redo | blocks fontfamily | link image media table | emoticons charmap | removeformat',
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-10 text-end">
                                    <br/>
                                    <span
                                        role="button"
                                        className="p-2 text-secondary icon"
                                        title="Send Email"
                                        onClick={onEmailFileClicked}
                                    >
                                        Send Email
                                        <FontAwesomeIcon icon={faEnvelope}  className="fa-icon"/>
                                    </span>
                                </div>
                            </div>
                        </form>

                    </main>

                </section>

            )

        } else {
            // show SMS fields
            content=(
                <section id="main_content">
                    <header>
                        <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faEnvelope} style={{fontSize:"30px", marginRight:"5px"}} />Text File</h1>
                        <div className='row'>
                            <div className='col-md-2'><br/></div>
                            <div className="col-md-3 text-end">
                                <select className='form-select' id="sendType" value={sendType} onChange={onSendTypeChanged}>
                                    <option value="sms">Send via Text</option>
                                    <option value="email">Send via Email</option>
                                </select>
                            </div>`
                        </div>
                    </header>
                    <main>
                        <form>
                            <div className="row mb-3">
                                <div className="col-md-5">
                                    <label className="form-label" htmlFor="smsNumber">
                                        Phone:
                                    </label>
                                    <input
                                        className="form-control"
                                        id="smsNumber"
                                        name="smsNumber"
                                        type="text"
                                        autoComplete="off"
                                        value={smsNumber}
                                        onChange={onPhoneChanged}
                                    />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-5">
                                    <textarea className='form-control' rows="5" id="smsMessage" onChange={onMessageChanged} value={smsMessage}>
                                    </textarea>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-5 text-end">
                                    <br/>
                                    <span
                                        role="button"
                                        className="p-2 text-secondary icon"
                                        title="Send Text Message"
                                        onClick={onSMSFileClicked}
                                    >
                                        Send Text Message
                                        <FontAwesomeIcon icon={faEnvelope}  className="fa-icon"/>
                                    </span>
                                </div>
                            </div>
                        </form>
                    </main>
                </section>
            )
        }

    } else {
        // show upload fields
        content=(
            <section id="main_content">
                <header>
                    <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faFileCirclePlus} style={{fontSize:"30px", marginRight:"5px"}} />Upload File</h1>
                </header>
                <main>
                    <div className='row mb-3'>
                        <div className="col-md-6">
                            <input id="filename" type="file" onChange={handleFileChange} className='form-control' accept="application/pdf"/>
    
                            {file && (
                                <div className="mt-2 text-sm">
                                    <p>File name: {file.name}</p>
                                    <p>Size: {(file.size / 1024).toFixed(2)} KB</p>
                                    <p>Type: {file.type}</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-md-6 text-end">
                            <span
                                role="button"
                                className="p-2 text-success icon"
                                title="Upload"
                                onClick={handleFileUpload}
                            >
                                Upload File
                                <FontAwesomeIcon icon={faFileCirclePlus}  className="fa-icon"/>
                            </span>
                        </div>
                    </div>
                </main>
            </section>
        )    
    }

    return content
  
}

export default FileUploader